import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { appGetHubById } from '../../store/hubs'
import { appCreateSponsor, appUpdateSponsor, uploadSponsorImage } from '../../store/sponsor'
import ImageUpload from '../../components/ImageUpload'
import { appGetAllUser } from '../../store/user'
import { appAllGetPaymentSettings } from '../../store/paymentsetting'
import { toCamelCase } from '../../utils/Function'

function NewSponsor() {
	const { id } = useParams()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')
	const hubDetails = useSelector(state => state?.hubReducer?.hubDetails)
	const Sanstha = useSelector(state => state?.sansthaReducer?.sanstha)
	const sponsor = useSelector(state => state?.sponsorReducer.sponsor)
	const payment = useSelector(state => state.paymentSettingsReducer.payment)
	const [startDate, setStartDate] = useState(new Date())
	const [endDate, setEndDate] = useState(
		new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
	)
	const users = useSelector(state => state?.usersReducer.users)

	const allCommunityFee = payment?.allcommunity || 0
	const communityFee = payment?.community?.price || 0
	const sansthaFee = payment?.sanstha?.price || 0

	const today = new Date().toISOString().split('T')[0]

	const nextYearDate = new Date()
	nextYearDate.setFullYear(nextYearDate.getFullYear() + 1)
	const nextYear = nextYearDate.toISOString().split('T')[0]

	useEffect(() => {
		dispatch(appGetHubById(hubId || permissionOfHub))
		dispatch(appAllGetPaymentSettings())
	}, [])

	const handleSansthaChange = option => {
		formik.setFieldValue('sanstha', option?.value)
		dispatch(
			appGetAllUser({
				page: 1,
				limit: 1000,
				hub: hubId || permissionOfHub,
				sansthaId: option?.value,
			}),
		)
	}

	useEffect(() => {
		if (sponsor && id) {
			const selectedsponsor = Array.isArray(sponsor) ? sponsor.find(c => c._id === id) : sponsor
			if (selectedsponsor && selectedsponsor.hub && selectedsponsor.hub._id) {
				dispatch(appGetAllUser({ page: 1, limit: 1000, hub: selectedsponsor.hub._id }))
			}
		}
	}, [sponsor, id, dispatch])

	useEffect(() => {
		if (sponsor && id) {
			const selectedsponsor = Array.isArray(sponsor) ? sponsor.find(c => c._id === id) : sponsor
			if (selectedsponsor) {
				formik.setFieldValue('name', selectedsponsor?.name)
				formik.setFieldValue('hub', selectedsponsor?.hub?._id || '')
				formik.setFieldValue('sanstha', selectedsponsor?.sanstha?._id || '')
				formik.setFieldValue('description', selectedsponsor?.description)
				formik.setFieldValue('image', selectedsponsor?.image)
				formik.setFieldValue('user', selectedsponsor?.user?._id || '')
				formik.setFieldValue('sponsorDate', selectedsponsor?.sponsorDate || '')
				formik.setFieldValue('sponsorfee', selectedsponsor?.sponsorfee || '')
				formik.setFieldValue('note', selectedsponsor?.note || '')
				if (selectedsponsor?.startDate) {
					const date = new Date(selectedsponsor.startDate)
					setStartDate(date)
					formik.setFieldValue('startDate', date.toISOString().split('T')[0])
				}
				if (selectedsponsor?.endDate) {
					const date = new Date(selectedsponsor.endDate)
					setEndDate(date)
					formik.setFieldValue('endDate', date.toISOString().split('T')[0])
				}
			}
		}
	}, [sponsor])

	const formik = useFormik({
		initialValues: {
			name: '',
			image: '',
			hub: '',
			// description: '',
			sanstha: '',
			user: '',
			startDate: today || '',
			endDate: nextYear || '',
			sponsorDate: '',
			sponsorfee: 0,
			note: '',
		},
		validationSchema: Yup.object({
			image: Yup.string()
				.required('Image is required')
				.test('is-valid-url', 'Invalid image', value => {
					return value && value !== '/img/default-placeholder.jpg'
				}),
			startDate: Yup.string().required('Start Date is Required'),
			endDate: Yup.string().required('End Date is Required'),
			user: Yup.string().required('User is required'),
		}),
		onSubmit: values => {
			let sponsorName = values.name
			if (values.user) {
				const selectedUser = Array.isArray(users) ? users.find(u => u._id === values.user) : null
				if (selectedUser) {
					sponsorName = selectedUser.firstName
				}
			}
			const temp_obj = {
				// name: sponsorName,
				image: values?.image,
				hub: hubId || permissionOfHub,
				// description: values?.description,
				sanstha: values?.sanstha,
				user: values?.user,
				startDate: values?.startDate,
				endDate: values?.endDate,
				sponsorDate: values?.sponsorDate,
				sponsorfee: values?.sponsorfee,
				amount: Number(values?.sponsorfee || 0),
				note: values?.note,
				navigate: navigate,
			}

			const filtered_obj = Object.fromEntries(
				Object.entries(temp_obj).filter(
					([key, value]) =>
						value !== '' && value !== null && value !== undefined && key !== 'navigate',
				),
			)
			filtered_obj.navigate = navigate

			if (id) {
				dispatch(appUpdateSponsor({ ...filtered_obj, id })).then(() => {
					navigate('/sponsor')
				})
			} else {
				dispatch(appCreateSponsor(filtered_obj)).then(() => {
					formik.resetForm()
					navigate('/sponsor')
				})
			}
		},
	})

	useEffect(() => {
		if (hubId || permissionOfHub) {
			formik.setFieldValue('hub', hubId || permissionOfHub)
		}
	}, [hubId, permissionOfHub])

	useEffect(() => {
		if (!payment) return
		if (id) return

		const hasHub = Boolean(formik.values.hub)
		const hasSanstha = Boolean(formik.values.sanstha)

		let fee = allCommunityFee

		if (hasHub && !hasSanstha) fee = communityFee
		if (hasHub && hasSanstha) fee = sansthaFee

		formik.setFieldValue('sponsorfee', fee)
	}, [formik.values.sanstha, payment])

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading">
					<div>
						<span>Sponsor</span> <span>/ {id ? 'Edit Sponsor' : 'New Sponsor'}</span>
					</div>
				</div>
				<div className="card card-default">
					<div className="card-body">
						<form onSubmit={formik.handleSubmit}>
							<div className="row">
								<div className="col-md-6">
									<div className="form-group">
										<label>Sponsored on Community level </label>
										<Select
											name="_id"
											// onChange={option => {
											// 	formik.setFieldValue('hubDetails', option?.value)
											// }}
											className="basic-multi-select"
											classNamePrefix="select Community..."
											isDisabled={true}
											value={
												hubDetails?._id
													? {
															value: hubDetails._id,
															label: toCamelCase(hubDetails?.name),
													  }
													: null
											}
											placeholder="Select.."
										/>
										{formik.touched.hub && formik.errors.hub ? (
											<div style={{ color: 'red' }}>{formik.errors.hub}</div>
										) : null}
									</div>
								</div>
								<div className="col-md-6">
									<ImageUpload
										uploadFunction={uploadSponsorImage}
										fieldName="image"
										value={formik.values.image}
										onChange={value => formik.setFieldValue('image', value.url)}
										error={formik.touched.image && formik.errors.image ? formik.errors.image : null}
									/>
								</div>
							</div>
							<div className="row" style={{ padding: '0 0 15px 0' }}>
								<div className="col-md-6">
									<div className="form-group">
										<label>Sponsored on Sanstha level</label>
										<Select
											options={
												Array.isArray(Sanstha)
													? Sanstha.map(place => ({
															value: place._id,
															label: toCamelCase(place?.name),
													  }))
													: []
											}
											onChange={handleSansthaChange}
											value={
												Array.isArray(Sanstha)
													? Sanstha.filter(option => option._id === formik?.values?.sanstha).map(
															option => ({
																value: option._id,
																label: toCamelCase(option?.name),
															}),
													  )[0]
													: null
											}
											placeholder="Select Sanstha.."
										/>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group">
										<label>Select Users</label>
										<Select
											options={
												Array.isArray(users)
													? users.map(user => ({
															value: user._id,
															label: `${user.firstName} ${user.lastName || ''} (${user.mobile ||
																''})`,
													  }))
													: []
											}
											onChange={option => {
												formik.setFieldValue('user', option?.value)

												const selectedUser = Array.isArray(users)
													? users.find(u => u._id === option?.value)
													: null

												if (selectedUser) {
													formik.setFieldValue('name', selectedUser.firstName)
												}
											}}
											value={
												Array.isArray(users)
													? users
															.filter(user => user._id === formik.values.user)
															.map(user => ({
																value: user._id,
																label: `${user.firstName} ${user.lastName || ''} (${user.mobile ||
																	''})`,
															}))[0] || null
													: null
											}
											placeholder="Select User..."
										/>

										{formik.touched.user && formik.errors.user ? (
											<div style={{ color: 'red' }}>{formik.errors.user}</div>
										) : null}
									</div>
								</div>
								{/* 
								<div className="col-md-6">
									<div className="form-group">
										<label>Name </label>
										<input
											className="form-control"
											name="name"
											type="text"
											onChange={formik.handleChange}
											value={formik.values.name}
										/>
									</div>
								</div> */}

								{/* <div className="col-md-6">
									<div className="form-group">
										<label>Description </label>
										<textarea
											className="form-control"
											name="description"
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											value={formik.values.description}
											rows="3"
										/>
										{formik.touched.description && formik.errors.description ? (
											<div style={{ color: 'red' }}>{formik.errors.description}</div>
										) : null}
									</div>
								</div> */}
							</div>

							<div className="row">
								<div className="col-md-6">
									<div className="form-group">
										<label>Date of offline payment received</label>

										<input
											type="date"
											className="form-control"
											value={formik.values.sponsorDate || ''}
											onChange={e => {
												const rawValue = e.target.value
												if (!rawValue) {
													formik.setFieldValue('sponsorDate', '')
													return
												}

												const dateObj = new Date(rawValue)
												if (isNaN(dateObj.getTime())) return

												formik.setFieldValue('sponsorDate', rawValue)
											}}
										/>
										{formik.touched.sponsorDate && formik.errors.sponsorDate ? (
											<div style={{ color: 'red' }}>{formik.errors.sponsorDate}</div>
										) : null}
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group">
										<label>Sponsor Fee </label>
										<input
											type="number"
											className="form-control"
											name="sponsorfee"
											value={formik.values.sponsorfee ?? 0}
											readOnly
										/>
									</div>
								</div>

								<div className="col-md-6">
									<div className="form-group">
										<label>Notes (payment details and received by)</label>
										<textarea
											className="form-control"
											name="note"
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											value={formik.values.note}
											rows="3"
										/>
									</div>
								</div>
							</div>

							<div className="row" style={{ padding: '0 0 15px 0' }}>
								<div className="col-md-6">
									<div className="form-group">
										<label>Start Date </label>
										<input
											type="date"
											className="form-control"
											value={formik.values.startDate || ''}
											onChange={e => {
												if (!e.target.value) {
													formik.setFieldValue('startDate', '')
													formik.setFieldValue('endDate', '')
													setStartDate(null)
													setEndDate(null)
													return
												}
												const dateValue = new Date(e.target.value)
												if (isNaN(dateValue.getTime())) {
													return
												}
												setStartDate(dateValue)
												let dateOnly = dateValue.toISOString().split('T')[0]
												formik.setFieldValue('startDate', dateOnly)

												const nextYear = new Date(dateValue)
												nextYear.setFullYear(nextYear.getFullYear() + 1)
												setEndDate(nextYear)
												formik.setFieldValue('endDate', nextYear.toISOString().split('T')[0])
											}}
										/>
										{formik.touched.startDate && formik.errors.startDate ? (
											<div style={{ color: 'red' }}>{formik.errors.startDate}</div>
										) : null}
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group">
										<label>End Date </label>
										<input
											type="date"
											className="form-control"
											value={formik.values.endDate || ''}
											readOnly
										/>
										{formik.touched.endDate && formik.errors.endDate ? (
											<div style={{ color: 'red' }}>{formik.errors.endDate}</div>
										) : null}
									</div>
								</div>
							</div>
							<div>
								<button
									className="btn btn-labeled btn-success mb-2"
									type="submit"
									style={{ fontSize: '17px' }}
								>
									<span className="btn-label">
										<i className="fa fa-check"></i>
									</span>
									{id ? 'Update' : 'Create'}
								</button>
								<span style={{ padding: '0 10px' }}>or</span>
								<button
									className="btn btn-labeled btn-secondary mb-2"
									type="button"
									style={{ fontSize: '17px' }}
									onClick={() => navigate('/sponsor')}
								>
									<span className="btn-label">
										<i className="fa fa-times"></i>
									</span>
									Cancel
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	)
}
export default NewSponsor
